export const greetings = {
  fleetGreetings: "车间问候语",
  greetingsName: "问候语标题",
  greetingsText: "问候语播报内容",
  applyFleet: "应用车间",
  creator: "创建者",
  addGreetings: "新建问候语",
  voiceType: "音色",
  voiceLanguage: "语言",
  voiceSpeed: "语速",
  mandarin: "中文",
  english: "英文",
  voiceMale: "男声",
  voiceFemale: "女声",
  fastSpeed: "快速",
  mediumSpeed: "中速",
  slowSpeed: "慢速",
  tryListen: "试听",
  editGreetings: "编辑问候语",
  pleaseInputGreetingsName: "请输入问候语标题",
  pleaseInputGreetingsText: "请输入问候语内容",
  applyFleets: "应用车间",
  priority: "优先级",
  common: "默认",
  overlay: "优先",
  greetingsDeleteTip:
    "问候语{0}将被删除。确定要继续吗？| 问候语{0}将被删除, 该问候语有关联车间。确定要继续吗？| 问候语{0}将被删除, 一个或多个问候语有关联车间。确定要继续吗？",
  listenFailed: "试听失败, 请重试。",
  greetingNameExist: "问候语标题已存在",
  powerOnGreetings: "开机问候语",
  defaultGreetings: "默认问候语",
  priorityGreetings: "优先问候语",
  playFrequency: "播放频率",
  priorityGreetingsStartEndTime: "优先问候语起止时间",
  onlyOnce: "仅一次",
  PlayWhenPowerOn: "每次开机播放",
  PlayWhenFirstPowerOnEveryDay: "每日首次开机播放",
  greetingSetting: "开机问候语设置",
  greetingsDetail: "问候语详情",
};
